import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

/** Lists the accounts you blocked so you can undo it. Hidden when there are none. */
export default function BlockedUsersPanel({ className = "" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/blocks").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (!items.length) return null;

  const unblock = async (id) => {
    try {
      await api.delete(`/users/${id}/block`);
      setItems((prev) => prev.filter((x) => x.id !== id));
      toast.success("Utilisateur débloqué.");
    } catch { toast.error("Impossible de débloquer."); }
  };

  return (
    <section className={`rounded-3xl p-5 border border-white/10 bg-white/[0.02] ${className}`} data-testid="blocked-users-panel">
      <h3 className="text-sm font-black text-white uppercase tracking-wider">Comptes bloqués</h3>
      <ul className="mt-3 space-y-2">
        {items.map((u) => (
          <li key={u.id} className="flex items-center justify-between gap-3 text-sm text-zinc-300">
            <span className="truncate">{u.name}</span>
            <button type="button" onClick={() => unblock(u.id)} className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/15 text-white text-xs font-bold" data-testid={`unblock-${u.id}`}>
              Débloquer
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
